import axios from 'axios';
import { getField, updateField } from 'vuex-map-fields';

const url = 'https://api.bi-assobens.com.br/v1';
// const url = 'http://localhost:3000/v1';

export default {
  namespaced: true,
  state: {
    dealers: [],
  },

  mutations: {
    updateField,
    SET_DEALERS(state, payload) {
      state.dealers = payload;
    },
  },

  actions: {
    // eslint-disable-next-line
    async getDealers({ commit }, obj) {
      const { data } = await axios.get(`${url}/dealers`, {
        headers: {
          // 'x-access-token': obj.token,
          'integration-key': '9e1a17ce5b329d3bf3cd0e618cfd83d57084f7944a9236ed2e2e86c2fba865b1',
        },
      });

      commit('SET_DEALERS', data.dealers);
    },

    // eslint-disable-next-line
    async removeDealer({ commit }, obj) {
      await axios.put(
        `${url}/user/${obj.userId}`,
        { dealerId: obj.dealerId },
        { headers: { 'x-access-token': obj.token } },
      );
    },
  },

  getters: { getField },
};
